<template>
    <div class="compare-project-types-for-responsibles">

        <div v-if="!loading">
            <div class="employees-wrapper" v-if="employees && !loading && $auth.user().roles[0].name !== 'project-responsible'">
                <div v-for="employee in employees" :key="'employee_' + employee.relation_id">
                    <div class="employee" :class="{'selected': selectedEmployee && selectedEmployee.relation_id === employee.relation_id}" @click="selectedEmployee = employee">
                        {{ employee.first_name }} {{ employee.last_name }}
                    </div>
                </div>
            </div>

            <div>
                <div class="info" v-if="!selectedEmployee && $auth.user().roles[0].name !== 'project-responsible'">
                    Vælg en opgaveansvarlig for at se et overblik over hans/hendes værdikæde her
                </div>
                <div class="info" v-if="!selectedEmployee && $auth.user().roles[0].name === 'project-responsible'">
                    Vi kunne ikke finde din værdikæde. Kontakt venligst din administrator.
                </div>
                <div v-if="selectedEmployee">
                    <responsible-valuechain-single :data="selectedEmployee"></responsible-valuechain-single>
                </div>
            </div>
        </div>

        <box-loading height="350" v-else />

    </div>
</template>

<script>
import * as employeeService from '@/services/employeeService'

export default {
    data () {
        return {
            selectedEmployee: null,
            loading: true,
            employees: []
        }
    },
    created () {
        this.getData()
        console.log('user', this.$auth.user())
    },
    methods: {
        getData () {
            this.selectedRow = null
            this.loading = true
            let params = {
                // date_from: this.$store.getters.getStartDate,
                date_from: '2021-10-01',
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid
            }
            employeeService.responsibleValuechain(params, (response) => {
                console.log(response.data)
                this.employees = response.data
                this.$emit('finishedLoading', this.employees.length)
                this.loading = false
                if (this.$auth.user().roles[0].name === 'project-responsible') {
                    this.employees.forEach((employee) => {
                        console.log(employee)
                        if (employee.relation_id === this.$auth.user().relation_employee_id) {
                            this.selectedEmployee = employee
                        }
                    })
                    if (!this.selectedEmployee) {
                        alert('Vi kunne ikke finde din værdikæde. Kontakt venligst din administrator.')
                    }
                }
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        selectEmployee (employee) {
            this.selectedRow = employee.row
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.relation_id === this.selectedRow.relation_id) {
                return 'selected'
            }
        }
    },
    components: {
        'responsible-valuechain-single': require('./components/responsibleValuechainSingle.vue')
    }
}
</script>

<style lang="scss" scoped>
.employees-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0px;

    .employee {
        background: white;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
        padding: 6px 12px;
        border-radius: 4px;
        margin: 0px 10px 10px 0px;
        cursor: pointer;

        &:not(.selected):hover {
            background: #efefef;
        }

        &.selected {
            background: #172b43;
            color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// responsibleValuechain.vue?4f1d3ac0